export default __webpack_public_path__ + "static/media/caret-down-white.8d02ace6.svg";